import React from "react"
import PropTypes from "prop-types"
import { values, sortBy, omit, get } from "lodash"
import { Link } from "react-router"

import {
  Modal, FormGroup, Row, Col, Glyphicon,
  ControlLabel, FormControl, Form, Table,
} from 'react-bootstrap'

import { allCountries } from "../../lib/countries"
import CountrySelector from '../components/CountrySelector.jsx'
import Button from '../components/Button.jsx'
import { getText, translateCity } from '../lib/text.js'
import { randstr } from '../../lib/Tools'
import MarkdownField from '../lib/MarkdownField'
import TranslateLink from '../components/TranslateLink';

function getStationGeolocationText(city, key) {
  const pl = get(city, ["stations", key, "preciseLocation"], null)
  return pl ? `${pl.address} (${pl.latitude}, ${pl.longitude})` : "..."
}

function getGeolocationText(city) {
  const pl = city.preciseLocation
  return pl ? `${pl.address} (${pl.latitude}, ${pl.longitude})` : "..."
}

/**
 *
 */

const ModalCityEditor = ({ city, onChange, onClose }) => {
  if (!city) return <Modal show>Cargando...</Modal>

  return (
    <Modal show bsSize="large" onHide={() => onClose()}>
      <Modal.Header>
        <Modal.Title>{getText("Editar")}: {translateCity(city)}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col md={6}>
            <CountrySelector
              value={city.country}
              onChange={country => onChange({ country })}
            />
            <FormGroup>
              <ControlLabel>{getText("spanish_name")}</ControlLabel>
              <FormControl
                onChange={evt => onChange({ name: evt.target.value })}
                value={city.name}
              />
            </FormGroup>
            <FormGroup>
              <ControlLabel>{getText("chinese_name")} <small><TranslateLink text={city.chinese} /></small></ControlLabel>
              <FormControl
                onChange={evt => onChange({ chinese: evt.target.value })}
                value={city.chinese}
              />
            </FormGroup>

            {
              city.country != "Spain" && city.country != "China" && (
                <FormGroup>
                  <ControlLabel>{allCountries[city.country].flag} Nombre en idioma local</ControlLabel>
                  <FormControl
                    onChange={evt => onChange({ localName: evt.target.value })}
                    value={city.localName}
                  />
                </FormGroup>
              )
            }

            <span>Geolocation: {getGeolocationText(city)}</span>
          </Col>
          <Col md={6}>
            <MarkdownField
              label="🇪🇸 Notas sobre la ciudad"
              value={city.notes || ""}
              onChange={notes => onChange({ notes })}
            />
          </Col>
        </Row>

        <hr />

        <Table condensed hover>
          <thead>
            <tr>
              <th style={{textAlign: "center"}}>#</th>
              <th>Nombre</th>
              <th>Dirección</th>
              <th style={{textAlign: "center"}}>Eliminar</th>
            </tr>
          </thead>
          <tbody>
            {
              sortBy(values(city.stations), "creation").map((station, i) => (
                <tr key={station.key}>
                  <td style={{textAlign: "center"}}>{i + 1}</td>
                  <td style={{width: 250}}>
                    <Form inline>
                      <FormGroup>
                        <ControlLabel>🇪🇸</ControlLabel>
                        <FormControl
                          value={station.name}
                          onChange={evt => onChange({
                            stations: {
                              ...city.stations,
                              [station.key]: { ...station, name: evt.target.value }
                            }
                          })}
                        />
                      </FormGroup>
                    </Form>
                    <Form inline>
                      <FormGroup>
                        <ControlLabel>🇨🇳</ControlLabel>
                        <FormControl
                          value={station.title}
                          onChange={evt => onChange({
                            stations: {
                              ...city.stations,
                              [station.key]: { ...station, title: evt.target.value }
                            }
                          })}
                        />
                      </FormGroup>
                    </Form>
                  </td>
                  <td>
                    <FormControl
                      value={station.address}
                      onChange={evt => onChange({
                        stations: {
                          ...city.stations,
                          [station.key]: { ...station, address: evt.target.value }
                        }
                      })}
                    />
                    <span>Geolocation: {getStationGeolocationText(city, station.key)}</span>
                  </td>
                  <td style={{textAlign: "center"}}>
                    <Button
                      onClick={() => onChange({ stations: omit(city.stations, station.key) })}
                      glyph="minus"
                    />
                  </td>
                </tr>
              ))
            }
          </tbody>
        </Table>

        <Button
          glyph="plus"
          onClick={() => {
            const key = randstr()
            onChange({ stations: {
              ...city.stations,
              [key]: { name: "", address: "", key, creation: Date.now() }
            }})
          }}
        >
          {getText("Añadir estación")}
        </Button>

      </Modal.Body>
      <Modal.Footer>
        <Link to={`/private/log/cities/${city._id}`} style={{ marginRight: 20 }}>
          <Glyphicon glyph="list" /> Ver Log
        </Link>
        <Button
          bsStyle="success"
          onClick={() => onClose()}
        >
          {getText("OK")}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}


ModalCityEditor.propTypes = {
  // #TODO update these
  onChange: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  city: PropTypes.object.isRequired
}

export default ModalCityEditor
